/* DryWell additions: shows up to two suggested add-ons in the cart drawer
   that aren't already in the cart. Reads the cart lines the drawer renders. */
(() => {
  'use strict';
  const drawer = document.querySelector('[data-cart-drawer]');
  const upsell = drawer && drawer.querySelector('[data-upsell]');
  const lines = drawer && drawer.querySelector('[data-cart-items]');
  if (!upsell || !lines) return;
  const handleOf = (href) => ((href || '').split('/products/')[1] || '').split(/[?#/]/)[0];
  const sync = () => {
    const inCart = new Set(Array.from(lines.querySelectorAll('.line__title')).map((a) => handleOf(a.getAttribute('href'))));
    let shown = 0;
    upsell.querySelectorAll('[data-upsell-item]').forEach((li) => {
      const show = inCart.size > 0 && !inCart.has(li.dataset.handle) && shown < 2;
      li.hidden = !show;
      if (show) shown += 1;
    });
    upsell.hidden = shown === 0;
  };
  new MutationObserver(sync).observe(lines, { childList: true });
  sync();
})();

/* Homepage product grid: category tabs filter the cards in place. */
(() => {
  'use strict';
  document.querySelectorAll('[data-pg]').forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-pg-tab]'));
    const cards = Array.from(section.querySelectorAll('.gc'));
    const empty = section.querySelector('[data-pg-empty]');
    const count = section.querySelector('[data-pg-count]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const handle = tab.dataset.pgTab;
      tabs.forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', String(on)); });
      let shown = 0;
      cards.forEach((card) => {
        const show = handle === 'all' || (' ' + card.dataset.cats + ' ').includes(' ' + handle + ' ');
        card.hidden = !show;
        if (show) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown === 1 ? count.dataset.one : count.dataset.other.replace('__count__', String(shown));
    }));
  });
})();

/* "Need help?" assistant: instant answers to common questions, then email. */
(() => {
  'use strict';
  const root = document.querySelector('[data-help]');
  if (!root) return;
  let data;
  try { data = JSON.parse(root.querySelector('[data-help-data]').textContent); } catch (_) { return; }
  const fab = root.querySelector('[data-help-toggle]');
  const panel = root.querySelector('.help__panel');
  const log = root.querySelector('[data-help-log]');
  const chips = root.querySelector('[data-help-chips]');
  const form = root.querySelector('[data-help-form]');
  const input = root.querySelector('[data-help-input]');
  const add = (text, who, link) => {
    const msg = document.createElement('div');
    msg.className = 'help__msg help__msg--' + who;
    msg.textContent = text;
    if (link && link.href) {
      const a = document.createElement('a');
      a.className = 'help__link'; a.href = link.href; a.textContent = link.label + ' →';
      msg.append(document.createElement('br'), a);
    }
    log.append(msg);
    log.scrollTop = log.scrollHeight;
  };
  const answer = (topic) => {
    const typing = document.createElement('div');
    typing.className = 'help__msg help__msg--bot help__typing'; typing.innerHTML = '<span></span><span></span><span></span>';
    log.append(typing); log.scrollTop = log.scrollHeight;
    setTimeout(() => {
      typing.remove();
      if (topic) add(topic.a, 'bot', { href: topic.link, label: topic.label });
      else add(data.fallback, 'bot', { href: 'mailto:' + data.email, label: 'Email us' });
    }, 650);
  };
  data.topics.forEach((t) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'chip help__chip'; b.textContent = t.q;
    b.addEventListener('click', () => { add(t.q, 'user'); answer(t); });
    chips.append(b);
  });
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const q = input.value.trim(); if (!q) return;
    input.value = ''; add(q, 'user');
    const lower = q.toLowerCase();
    let best = null, score = 0;
    data.topics.forEach((t) => { const s = t.k.filter((k) => lower.includes(k)).length; if (s > score) { score = s; best = t; } });
    answer(best);
  });
  const setOpen = (open) => {
    panel.hidden = !open; fab.setAttribute('aria-expanded', String(open)); root.classList.toggle('is-open', open);
    if (open) input.focus(); else fab.focus();
  };
  fab.addEventListener('click', () => setOpen(panel.hidden));
  root.querySelector('[data-help-close]').addEventListener('click', () => setOpen(false));
  root.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) setOpen(false); });
})();

/* Live condensation: droplets form on the hero panel and slowly run down it. */
(() => {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-drops]').forEach((layer) => {
    const count = window.innerWidth < 750 ? 14 : 26;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < count; i += 1) {
      const d = document.createElement('i');
      const size = 4 + Math.random() * 9;
      d.style.setProperty('--x', (Math.random() * 100).toFixed(2) + '%');
      d.style.setProperty('--y', (Math.random() * 70).toFixed(2) + '%');
      d.style.setProperty('--s', size.toFixed(1) + 'px');
      d.style.setProperty('--fall', (60 + Math.random() * 220).toFixed(0) + 'px');
      d.style.setProperty('--d', (7 + Math.random() * 9).toFixed(2) + 's');
      d.style.setProperty('--delay', (-Math.random() * 14).toFixed(2) + 's');
      frag.append(d);
    }
    layer.append(frag);
  });
})();

/* Keep the floating help shortcut clear of mobile purchase controls. */
(() => {
  'use strict';
  const help = document.querySelector('[data-help]');
  const purchase = document.querySelector('body.template-product [data-product-form]');
  if (!help || !purchase || !('IntersectionObserver' in window)) return;
  new IntersectionObserver((entries) => {
    help.classList.toggle('help--buying', entries.some((entry) => entry.isIntersecting));
  }).observe(purchase);
})();
